<template>
  <!-- 主页 -->
  <MainPage class="index-container background" :style="{'background-image': `url(${bgImgUrl})`}" :class="[collapsed && 'collapsed']" :spin="spinning">
    <div class="right-main" :style="rightMainStyle">
      <!-- <div v-show="collapsed" class="right-title">{{ activeTwo && activeTwo.title }}</div> -->
      <div :class="['right-cotnent', !collapsed && 'lucency']">
        <div v-show="!collapsed && logo" class="logo img-wrapper">
          <img :src="logo"/>
        </div>
        <div class="router-container">
          <router-view/>
        </div>
      </div>
      <div v-show="!collapsed" class="left-bottom">
         <div class="img-wrapper">
            <img class="pointer" :src="require('@/static/icons/11.png')" @click="$refs.menuSettingnodal.open()"/>
          </div>
          <div class="img-wrapper">
            <img class="pointer" :src="require('@/static/icons/09.png')" @click="$refs.settingModal.open()"/>
          </div>
          <div class="img-wrapper">
            <img class="pointer" :src="require('@/static/icons/10.png')" @click="logout"/>
          </div>
        </div>
      <!-- <div v-show="collapsed" class="right-bottom bt1">
        <template v-for="twoMenu in getTwoMenus">
          <div :key="twoMenu.name" 
            :class="['bottom-menu pointer br1', getActiveTwoName == twoMenu.name && 'menu-active']"
            @click="setActiveTwo(twoMenu)"
          >{{ twoMenu.title }}</div>
        </template>
      </div> -->
    </div>
    <SettingModal ref="settingModal"></SettingModal>
   <MenuSettingModal ref="menuSettingnodal"></MenuSettingModal>
  </MainPage>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import icons from '@/static/icons'
import SettingModal from '../components/common/SettingModal.vue';
import MenuSettingModal from '../components/common/MenuSettingModal.vue';
export default {
  components: {
    SettingModal,
    MenuSettingModal
  },
  data() {
    return {
      spinning: true,
      icons,
    };
  },
  computed:{
    ...mapState(['activeOne', 'activeTwo', 'collapsed', 'floatVisibel', 'previewMenuIndex', 'basicConfig']),
    ...mapGetters(['getMenuList', 'getTwoMenus', 'getActiveTwoName']),
    //是否展示浮动菜单
    flostMenuShow(){
      return this.floatVisibel && this.previewMenuIndex != null && this.collapsed
    },
    //浮动菜单二级菜单列表
    floatTwoMenus(){
      if(this.previewMenuIndex == null){
        return []
      }
      return this.getMenuList[this.previewMenuIndex].children
    },
    /* 右侧上下样式 */
    rightMainStyle(){
      return {
        'z-index': this.previewMenuIndex != null ? 1 : 10
      }
    },
    logo(){
      let logo = this.basicConfig.logo
      if(logo) {
        return 'api/' + logo
      }
      return require('@/static/img/logo3.png')
    },
    bgImgUrl(){
      let innerBgImgUrl = this.basicConfig.innerBgImgUrl
      if(innerBgImgUrl) {
        return 'api/' + innerBgImgUrl
      }
      return require('@/static/img/bg.jpg')
    }
  },
  created(){
  },
  mounted(){
    this.$nextTick(function(){
      this.spinning = false
      //打开之前记录的菜单
      this.openRecordMenu()
      this.refreshTerminalMenu()
    })
  },
  methods:{
    ...mapMutations(['setActiveOne', 'setCollapsed', 'setActiveTwo', 'setFloatVisibel']),
    ...mapActions(['logout', 'openRecordMenu', 'openOneMenu','refreshTerminalMenu']),
    /** 点击一级菜单菜单 */
    menuClick(oneMenu, index){
      this.openOneMenu({oneMenu, index})
    },
    /** 关闭浮动菜单 */
    closeFloatMenu(){
      this.setFloatVisibel()
    },
  },
  watch: {
  }
};
</script>
<style lang="less" scoped>
@icon-height: 46px;//图标高度
@transition: .3s;//过渡效果

.index-container{
  background-size: cover;
  display: flex;
  > div{
    height: 100%;
  }
  .right-main{
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    >div{
      width: 100%;
    }
    @side-height: 40px;
    @side-border: @border;
    .right-title{
      height: @side-height;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      color: #d4ebff;
      letter-spacing: 2px;
      border-bottom: @side-border;
    }

    .right-cotnent{
      flex: 1;
      overflow: hidden;
      background: #f9f9f9;
      transition: @transition;
      display: flex;
      flex-direction: column;
      &.lucency{
        padding: 26px 35px;
        background: unset;
      }
      .logo{
        height: 70px;
        justify-content: flex-end;
      }
      .router-container{
        overflow: hidden;
        height: 100%;
        width: 100%;
      }
    }
    .left-bottom{
      display: flex;
      justify-content: right;
     .img-wrapper{
      width: 2.5vw;
      height: 2.5vw;
      margin-right: 0.5vw;
      margin-bottom: 2vh;
      img{
        height: 100%;
      }

     }
    }
  }
}
</style>
